export default "__VITE_ASSET__DHUAmext__"